import React, { useMemo } from 'react';

import useStoreTranslation from 'hooks/useStoreTranslation';
import { VehicleForCustomerSupport } from 'models/customerSupport';

import { Info } from '../styles';
import { Container, CarIcon, Title, ArrowIcon } from './styles';

type Props = {
  details: VehicleForCustomerSupport;
};

const Vehicle = ({ details }: Props) => {
  const { t } = useStoreTranslation();

  const days = useMemo(
    () =>
      details.quantityDays > 1
        ? t('tripCard.daily_plural', { count: details.quantityDays })
        : t('tripCard.daily', { count: details.quantityDays }),
    [details.quantityDays, t],
  );
  const pickUpDateTime = useMemo(
    () =>
      typeof details.pickupDateTime === 'string'
        ? new Date(details.pickupDateTime.replaceAll('Z', ''))
        : new Date(details.pickupDateTime),
    [details.pickupDateTime],
  );

  const dropOffDateTime = useMemo(
    () =>
      typeof details.droppOffDateTime === 'string'
        ? new Date(details.droppOffDateTime.replaceAll('Z', ''))
        : new Date(details.droppOffDateTime),
    [details.droppOffDateTime],
  );

  return (
    <Container>
      <CarIcon />
      <div>
        <Title>
          {t('tripCard.vehicleRent', { city: details.vehiclePickUpCityName || details.vehicleCityCode })}
          {details.vehiclePickUpCityName !== details.vehicleDropoffCityName && (
            <>
              <ArrowIcon />
              {details.vehicleDropoffCityName}
            </>
          )}
        </Title>
        <Info>
          {t('tripCard.bookingDateTime', { date: pickUpDateTime })} &mdash;{' '}
          {t('tripCard.bookingDateTime', { date: dropOffDateTime })}
        </Info>
        <Info>{days}</Info>
      </div>
    </Container>
  );
};

export default Vehicle;
